import React from 'react';
import VideoCamIcon from '@mui/icons-material/Videocam';

import { hasTrussSettingsPermission, shouldSynchronizeComponent } from '@paragon/login-tools';

import { toggleSynchronizeCamera } from '../../../store/slices/visualOptionsSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function SynchronizeButton() {
  const hasTrussSettingsPermissionValue = useAppSelector(hasTrussSettingsPermission);
  const hasSyncCameraPermission = useAppSelector(shouldSynchronizeComponent);

  const dispatch = useAppDispatch();

  if (!hasTrussSettingsPermissionValue || !hasSyncCameraPermission) return null;

  return (
    <ToolbarIconButton
      icon={<VideoCamIcon />}
      title="Synchronize Camera"
      onClick={() => {
        dispatch(toggleSynchronizeCamera());
      }}
    />
  );
}
